import { useNavigate } from "react-router";

import consumerStyle from "consumer/consumer.module.css";
import step2Style from "../step2.module.css";
import { convert_time } from "consumer/@@@/convert_time";
import { convert_grade } from "consumer/@@@/convert_grade";
import React from "react";

export default function List(props) {
	const navigate = useNavigate();

	const { gradeList, eventList, academyInfo, inProgressMap, reloadEvent } = props;

	const onNavigate = (event, schedule) => {
		navigate("/step3", {
			state: {
				branch_id: academyInfo["BranchID"],
				branch_name: academyInfo["BranchName"],
				event_id: event["id"],
				schedule_id: schedule["id"],
			},
		});

		reloadEvent(schedule["id"]);
	};

	function get_week(day) {
		const w = new Date(day);

		const w2 = w.getDay();

		switch (w2) {
			case 0:
				return "일";
			case 1:
				return "월";
			case 2:
				return "화";
			case 3:
				return "수";
			case 4:
				return "목";
			case 5:
				return "금";
			case 6:
				return "토";
			default:
				return "";
		}
	}

	return (
		<div className={step2Style["listWrap"]}>
			{eventList.map((value, index) => {
				const scheduleList = value["Schedules"];

				return (
					<div key={index} className={step2Style["eventWrap"]}>
						<div className={step2Style["eventHead"]}>
							<div className={step2Style["eventName"]}>{`<${value["name"]}>`}</div>
							<div className={step2Style["onlyEnrolled"]}>
								{(function () {
									if (value["onlyEnrolled"]) {
										return "재원생만 신청 가능";
									}
								})()}
							</div>
						</div>

						<div className={step2Style["scheduleWrap"]}>
							{scheduleList.map((v, i) => {
								const schedule_id = v.id;
								const addcount = inProgressMap[schedule_id] || 0;
								const currentCount = v.currentUserCount + addcount;

								// const isDisabled = currentCount >= v.targetNumber;

								const payment = v["payment"];

								return (
									<div
										key={i}
										className={step2Style["schedule"]}
										// style={{
										// 	opacity: isDisabled ? 0.5 : 1,
										// 	cursor: isDisabled ? "not-allowed" : "pointer",
										// 	pointerEvents: isDisabled ? "none" : "auto",
										// }}
										onClick={() => {
											// if(isDisabled) return;
											onNavigate(value, v);
										}}
									>
										<div
											style={{
												display: "flex",
												flexDirection: "column",
												justifyContent: "center",
												width: "250px",
											}}
										>
											<div
												style={{
													display: "flex",
													alignItems: "center",
													justifyContent: "flex-start",
													flexWrap: "wrap",
													marginBottom: "5px",
												}}
											>
												<div>
													{v["targetDate"]}({get_week(v["targetDate"])})
												</div>
												<div style={{ marginInline: "5px" }}></div>
												<div>{convert_time(v["targetTime"])}</div>
												<div style={{ marginInline: "5px" }}></div>
											</div>
											<div className={step2Style["gradeWrap"]}>
												{JSON.parse(v["targetGrades"]).map((a, b) => {
													return (
														<div key={b} className={step2Style["grade"]}>
															{convert_grade({
																grade_list: gradeList,
																grade: a,
															})}
														</div>
													);
												})}
											</div>
										</div>

										<div
											style={{
												display: "flex",
												flexDirection: "column",
												alignItems: "center",
												justifyContent: "center",
												minWidth: "120px",
												fontSize: "20px",
											}}
										>
											{payment !== 0 && (
												<div style={{ color: "red" }}>
													{(function () {
														return `${Number(payment).toLocaleString()}원`;
													})()}
												</div>
											)}

											<div>
												{v.currentUserCount < v.targetNumber ? `${v.currentUserCount} / ${v.targetNumber}` : "대기신청"}
											</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				);
			})}

			{eventList.length === 0 && <div className={consumerStyle["alarm"]}>등록된 일정이 없습니다.</div>}
		</div>
	);
}
